/**
 * @author:	Emmanuel SMITH <hey@emmanuel-smith.me>
 * project:	ets2-dashboard-skin
 * file: 	_history.js
 * Date: 	23/10/2020
 * Time: 	13:37
 */

export const HTY_EVENT = 'hty-event';

export const HTY_ZONE = {
  MAIN: 'Main',
  ZONE_GAME: 'Header/HeaderGameInformation',
  MENU: 'Menu',
  MENU_SKIN: 'Menu/Skin',
  MENU_CONFIG: 'Menu/Config',
  MAPS_INIT: 'Maps/Init',
  ERROR: 'Error'
};
export const HTY_LEVEL = {
  DEBUG: 'DEBUG',
  INFO: 'INFO',
  WARNING: 'WARNING',
  ERROR: 'ERROR',
  CRITICAL: 'CRITICAL'
};
export const HTY_MAX_LINES = 20;
